<div fxLayout="column" fxLayout.lt-md="column" class="liquitics-box" ngClass.gt-sm="metric-bar" (click)="zoomToAlerts()">
    <div fxFlex="1 1 80%" fxLayout="column" class="alert-metric-summaries">
        <div fxFlex="auto" fxLayout="column" *ngIf="(criticalCount+warningCount) == 0">
            <span fxFlex="1 1 100%" class="ok-icon fa fa-check-circle"></span>
        </div>
        <div fxFlex="auto" fxLayout="column" *ngIf="streamError">
            <span fxFlex="1 1 100%" class="stream-error-icon pi pi-exclamation-circle"></span>
        </div>
        <app-alert-table fxFlex="1 1 auto" *ngIf="(criticalCount+warningCount) > 0" [filterFunction]="filterFunction" [displayedColumns]="['icon', 'minutesLate', 'description', 'currencyAmount']"></app-alert-table>
    </div>
    <div fxFlex="1 1 20%" class="alert-metric-badges" fxLayout="row">
        <div fxFlex="1 1 50%" class="alert-metric-critical-badge liquitics-h3">
            <mat-icon>notifications_active</mat-icon><span>{{criticalCount}}</span>
        </div>
        <div fxFlex="1 1 50%" class="alert-metric-warning-badge liquitics-h3">
            <mat-icon>info_outline</mat-icon><span>{{warningCount}}</span>
        </div>
    </div>
</div>